import { render, staticRenderFns } from "./UniversityListComponent.vue?vue&type=template&id=0b64f517"
import script from "./UniversityListComponent.vue?vue&type=script&lang=js"
export * from "./UniversityListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports